import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const BadgeX: IconNode = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z',
      },
    ],
    ['line', { x1: '15', x2: '9', y1: '9', y2: '15' }],
    ['line', { x1: '9', x2: '15', y1: '9', y2: '15' }],
  ],
];

export default BadgeX;
